<template>
  <div class="substep-review-team-insights">
    <div class="substep-header">
      <h3 data-testId="step-title">Review Team Insights</h3>
      <p>See what your team is focusing on, how they're spending their time, and where they can be more productive.</p>
    </div>
    <div class="select-team-member">
      <AppSelect
        v-model="teamMember"
        has-tooltip
        :options="teamMembers"
        tooltip-title="Select a team member to approve their timesheet"
        :select2-options="{ placeholder: 'Team member' }"
        @input="onTeamMemberChange"
      />
    </div>

    <div class="widgets row">
      <div class="col-sm-12 col-md-4 widget insights-activity-widget">
        <div class="widget-wrapper">
          <ActivityLevelWidget
            v-if="teamMember"
            :activity="activity"
          />
          <InsightsNoData
            v-else
            type="empty_description"
          />
        </div>
      </div>

      <div class="col-sm-12 col-md-4 widget insights-top-apps-and-urls-widget">
        <div class="widget-wrapper">
          <TopAppsAndUrlsWidget
            v-if="teamMember"
            :top-apps-and-urls="topAppsAndUrls"
          />
          <InsightsNoData
            v-else
            type="empty_description"
          />
        </div>
      </div>

      <div class="col-sm-12 col-md-4 widget insights-work-time-classification-widget">
        <div class="widget-wrapper">
          <WorkTimeClassificationWidget
            v-if="teamMember"
            :work-time-classification="workTimeClassification"
          />
          <InsightsNoData
            v-else
            type="empty_description"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import WorkTimeClassificationWidget from './components/WorkTimeClassificationWidget.vue';
import ActivityLevelWidget from './components/ActivityLevelWidget.vue';
import TopAppsAndUrlsWidget from './components/TopAppsAndUrlsWidget.vue';
import InsightsNoData from '~/components/insights/InsightsNoData.vue';

export default {
  name: 'ReviewTeamInsights',
  components: {
    WorkTimeClassificationWidget,
    ActivityLevelWidget,
    TopAppsAndUrlsWidget,
    InsightsNoData,
  },
  mixins: [GettingStartedMixin],
  props: {
    insightsData: {
      type: Object,
      default: () => ({}),
      validator: (data) => {
        const itemKeys = Object.keys(data);

        return (
          itemKeys.includes('work_time_classification') &&
          itemKeys.includes('activity') &&
          itemKeys.includes('top_apps_and_urls')
        );
      },
    },
    teamMembers: {
      type: Array,
      default: () => [],
      validator: (teamMembers) => {
        return teamMembers.every((teamMember) => {
          return typeof teamMember.id === 'number' && typeof teamMember.text === 'string';
        });
      },
    },
  },
  data: () => ({
    teamMember: null,
  }),
  computed: {
    workTimeClassification() {
      if (this.teamMember && this.insightsData.work_time_classification) {
        return this.insightsData.work_time_classification[this.teamMember.toString()] || {};
      }

      return {};
    },
    topAppsAndUrls() {
      if (this.teamMember && this.insightsData.top_apps_and_urls) {
        return this.insightsData.top_apps_and_urls[this.teamMember.toString()] || {};
      }

      return {};
    },
    activity() {
      if (this.teamMember && this.insightsData.activity) {
        return this.insightsData.activity[this.teamMember.toString()] || {};
      }

      return {};
    },
  },
  methods: {
    onTeamMemberChange() {
      if (this.teamMember) {
        this.$emit('completeSubstep');
      }
    },
  },
};
</script>
